
module.exports = {
	Home: {
        systemName: 'management system',
		skinPeeler: 'Skin peeler',
		help: 'Help',
        language: 'language',
        Chinese: 'Chinese',
        English: 'English',
        German: 'German',

        homePage: 'home page',
        changePassword: 'Change Password',
        signOut: 'Sign out',
        goodMorning: 'Good morning',
        goodNoon: 'Good noon',
        goodAfternoon: 'Good afternoon',
        goodEvening: 'Good evening',
	},
    Btn: {
        queryBtn: 'query',
        resetBtn: 'Reset',
        addBtn: 'Add to',
        editBtn: 'edit',
        deleteBtn: 'delete'
    },
    Label: {
        name: 'name',
        loginName: 'Login name',
        role: 'role',
        state: 'state',
        mobile: 'mobile',
        type:'type',
      inRoleType:'test'
    },
    System: {
        inName: 'Please enter your name',
        inLoginName: 'Please enter your login name',
        seRoles: 'Please select roles',
        seStatus: 'Please select user status',
        adQuery: 'More conditions',
        basicQuery: 'Basic query',
        queryCriteria: 'query criteria',
        inMobile: 'Please enter your mobile',
        inType: 'Please select user type',
        inRoleType:'uuuuuuuuuuuuuuuuuuuuuuuuuuu'
    },
    FormTable: {

    },
    input: {

    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js